import { Outlet, useLocation } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';
import KickWidget from './KickWidget';
import CursorSpotlight from './CursorSpotlight';
import ScrollProgress from './ScrollProgress';
import LoginErrorModal from './LoginErrorModal';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Layout() {
  const location = useLocation();
  useScrollReveal();

  return (
    <div className="flex flex-col min-h-screen relative">
      <CursorSpotlight />
      <ScrollProgress />
      <Nav />
      <main key={location.pathname} className="page-enter flex-1 relative z-10 pt-16">
        <Outlet />
      </main>
      <Footer />
      <KickWidget />
      <LoginErrorModal />
    </div>
  );
}
